import { ContinentId, CountryOrRegionId } from './enum';

export const consentContinents = [ContinentId.Europe, ContinentId.NorthAmerica, ContinentId.SouthAmerica];
export const skystoneContinents = [ContinentId.Europe, ContinentId.NorthAmerica, ContinentId.SouthAmerica];

export const westernRegionBlackList = [
  CountryOrRegionId.Russia,
  CountryOrRegionId.Belarus,
  CountryOrRegionId.Moldova,
  CountryOrRegionId.Macedonia,
  CountryOrRegionId.Serbia,
  CountryOrRegionId.Montenegro,
  CountryOrRegionId.Bahamas,
];

// 亚洲包黑名单
export const asiaBlackList = [
  CountryOrRegionId.Cambodia,
  // CountryOrRegionId.Vietnam,
  CountryOrRegionId.China,
  // CountryOrRegionId.Korea,
  CountryOrRegionId.Bangladesh,
  CountryOrRegionId.Tajikistan,
  CountryOrRegionId.SolomonIslands,
  CountryOrRegionId.Vanuatu,
  CountryOrRegionId.India,
  CountryOrRegionId.Iran,
  CountryOrRegionId.Iraq,
  CountryOrRegionId.Syrian,
  CountryOrRegionId.Afghanistan,
  CountryOrRegionId.Mali,
  CountryOrRegionId.Zimbabwe,
  CountryOrRegionId.Angola,
  CountryOrRegionId.Congo,
  CountryOrRegionId.DemocraticCongo,
  CountryOrRegionId.Cameroon,
  CountryOrRegionId.Kenya,
  CountryOrRegionId.Yemen,
  CountryOrRegionId.Libya,
  CountryOrRegionId.Algeria,
  CountryOrRegionId.Tunisia,
  CountryOrRegionId.Georgia,
  CountryOrRegionId.Azerbaijan,
  CountryOrRegionId.Armenia,
  CountryOrRegionId.Morocco,
];

export const hmtRegionIds = [CountryOrRegionId.HongKong, CountryOrRegionId.Macao, CountryOrRegionId.TaiWan];

export const southeastAsiaRegionIds = [
  CountryOrRegionId.Thailand,
  CountryOrRegionId.Indonesia,
  CountryOrRegionId.Malaysia,
  CountryOrRegionId.Singapore,
  CountryOrRegionId.Vietnam,
  CountryOrRegionId.Philippines,
  CountryOrRegionId.Cambodia,
  CountryOrRegionId.Laos,
  CountryOrRegionId.Myanmar,
  CountryOrRegionId.Brunei,
  CountryOrRegionId.EastTimor,
];

export const globalBlackList = [...westernRegionBlackList, ...asiaBlackList];
